import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import _ from 'lodash';
import * as moment from 'moment';
import { ReservationMode } from '../../../../_shared/enums/reservationMode.enum';
import { Asset } from './../../../../_shared/model/asset.model';
import { Contractor } from './../../../../_shared/model/contractor.model';
import { Event } from './../../../../_shared/model/event.model';
import { OriginUrlPipe } from './../../../../_shared/pipes/origin-url.pipe';
import { HelperService } from './../../../../_shared/services/helper.service';

@Injectable({
    providedIn: 'root',
})
export class MainCalendarGuiService {
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public customTags: any = this.helper.loadCustomTags();
    constructor(
        private helper: HelperService,
        private xss: DomSanitizer,
        private originPipe: OriginUrlPipe,
    ) {}

    private sanitize(value: string): string {
        return this.xss.sanitize(SecurityContext.HTML, value);
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public generateBackgroundEventRender(element: any, model: any): any {
        // if (_.get(data, 'event.extendedProps.bsids')) {
        //     //"VIP" zunanja razpoložljivost za partnerje
        //     const imgPath = this.helper.getBusiness(_.get(data, 'event.extendedProps.bsids[0]')).iconPath;
        //     data.el.style.backgroundImage = `url(${imgPath})`;
        //     data.el.style.backgroundSize = '25px 25px';
        //     data.el.style.opacity = '0.4';
        //     //removej openForExternal classe
        //     data.el.classList.remove('mf-external-availability-event');
        //     data.el.classList.remove('mf-customer-availability-event');
        // } else if (data?.event?.extendedProps?.virtualOrdered || data?.event?.extendedProps?.virtualReadiness) {
        //     // render za HD razpolozljivost
        //     let bgUrl: string = '';
        //     let bgSize: string = '25px 25px';
        //     let bgPos: string = 'right top';
        //     if (data?.event?.extendedProps?.virtualOrdered && data?.event?.extendedProps?.virtualReadiness) {
        //         bgUrl =
        //             'url(../../../assets/app/media/img/naroceni.svg), url(../../../assets/app/media/img/pripravljenost.svg)';
        //         bgSize = '25px 50px';
        //         bgPos = 'right top 25px , right top';
        //     } else if (data?.event?.extendedProps?.virtualOrdered) {
        //         bgUrl = 'url(../../../assets/app/media/img/naroceni.svg)';
        //     } else if (data?.event?.extendedProps?.virtualReadiness) {
        //         bgUrl = 'url(../../../assets/app/media/img/pripravljenost.svg)';
        //     }

        //     // element.style.backgroundAttachment = `fixed`;
        //     data.el.style.backgroundImage = bgUrl;
        //     data.el.style.backgroundSize = bgSize;
        //     data.el.style.backgroundRepeat = 'repeat-y';
        //     data.el.style.backgroundPosition = bgPos;
        //     // data.el.style.opacity = '1';
        // }

        // if (element.classList.contains('fc-timegrid-event')) {
        // const model = data?.event?.extendedProps;
        // const element = data.el;
        const imgUrls: string[] = [];
        if (model?.virtualOrdered) {
            imgUrls.push('url(../../../assets/app/media/img/availability/naroceni.svg)');
        }
        if (model?.virtualReadiness) {
            imgUrls.push('url(../../../assets/app/media/img/availability/pripravljenost.svg)');
        }
        if (model?.services) {
            imgUrls.push('url(../../../assets/app/media/img/availability/h-hand_padd.svg)');
        }
        if (model?.openForExternalCustomer) {
            imgUrls.push('url(../../../assets/app/media/img/availability/customer.svg)');
        }
        // if (model?.openForExternal) {
        //corpo
        if (model?.openForExternal) {
            if (model?.bsids?.length > 0) {
                const url = this.helper.getBusiness(_.get(model, 'bsids[0]')).iconPath;
                imgUrls.push(`url(${url})`);
            } else {
                imgUrls.push('url(../../../assets/app/media/img/availability/corpo.svg)');
            }
        }
        // }
        if (imgUrls.length > 0) {
            element.style.backgroundImage = imgUrls.join(', ');
            element.style.backgroundSize = `30px ${30 * imgUrls.length}px`;
            element.style.backgroundRepeat = 'repeat-y';
            element.style.opacity = '0.4';
            element.style.backgroundPosition = imgUrls

                .map((_, i) => {
                    return `right top ${30 * i}px`;
                })
                .join(', ');
        }

        // return element;
        // }
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public generateEventRender(element: any, model: Event, subcontractors: Contractor[], view: any): any {
        //dodani subcontractorji za mapiranje, ker so nepopolni podatki, kakšni subcontractorji imajo samo ID brez imena
        element = $(element);
        // if (view?.type == 'timeGridDay') {
        //     const el = element.find('.fc-event-title')[0]?.innerHTML;
        //     const neew = `<div class="fc-description"><i class="la la-street-view"></i>${el}</div>`;
        //     element.find('.fc-event-title')[0].innerHTML = neew;
        // }
        if (
            view?.type == 'timeGridWeek' ||
            view?.type == 'resourceTimeGridWeek' ||
            view?.type == 'dayGridMonth' ||
            view?.type == 'resourceTimeGridDay' ||
            view?.type == 'timeGridDay'
        ) {
            this.generateIconsCalendar(model, element);
            const el = element.find('.fc-event-title')[0]?.innerHTML;
            const neew = `<div class="fc-description"><i class="la la-street-view"></i>${el}</div>`;
            element.find('.fc-event-title')[0].innerHTML = neew;
            if (_.has(model, 'serviceGroup.name') && !_.isNil(model.serviceGroup)) {
                element
                    .find('.fc-event-title')
                    .append('<div class="fc-description" ><i class="la la-archive"></i>' + this.sanitize(model.serviceGroup.name) + '</div>');
            } else {
                if (_.has(model, 'service.name')) {
                    element
                        .find('.fc-event-title')
                        .append('<div class="fc-description" ><i class="la la-hand-paper-o"></i>' + this.sanitize(model.service.name) + '</div>');
                }
            }
            if (_.get(model, 'contractor.subcontractors[0].name')) {
                element
                    .find('.fc-event-title')
                    .append(
                        '<div class="fc-description"><i class="la la-stethoscope"></i>' +
                            this.sanitize(model.contractor.subcontractors[0].name) +
                            '</div>',
                    );
            }
            if (model?.comment) {
                element
                    .find('.fc-event-title')
                    .append('<div class="fc-description"><i class="la la-sticky-note"></i>' + this.sanitize(model.comment) + '</div>');
            }
            if (model.customer?.importantComments?.comments?.length > 0) {
                const combinedImportantComments = model.customer.importantComments.comments.map(el => el?.comment?.trim()).join(', ');
                element.find('.fc-event-title').append(
                    `
                    <div class="fc-description" ><i class="la la-exclamation"></i> 
                    ${this.sanitize(
                        combinedImportantComments?.length > 80 ? `${combinedImportantComments.substring(0, 80)}...` : combinedImportantComments,
                    )} 
                </div>
                    `,
                );
            }
        }

        //month
        // dayGridMonth
        if ($(element).hasClass('fc-time-grid-event')) {
            this.generateIconsCalendar(model, element);
            if (_.has(model, 'serviceGroup.name')) {
                element
                    .find('.fc-event-title')
                    .append('<div class="fc-description" ><i class="la la-archive"></i>' + this.sanitize(model.serviceGroup.name) + '</div>');
            } else {
                if (_.has(model, 'service.name')) {
                    element
                        .find('.fc-event-title')
                        .append('<div class="fc-description" ><i class="la la-hand-paper-o"></i>' + this.sanitize(model.service.name) + '</div>');
                }
            }

            if (_.get(model, 'contractor.subcontractors[0].name')) {
                element
                    .find('.fc-event-title')
                    .append(
                        '<div class="fc-description"><i class="la la-stethoscope"></i>' +
                            this.sanitize(model.contractor.subcontractors[0].name) +
                            '</div>',
                    );
            } else if (_.get(model, 'contractor.subcontractors[0].id')) {
                const subcontractor = subcontractors.find(sub => {
                    if (sub.id === model.contractor.subcontractors[0].id) return sub;
                });
                if (subcontractor) {
                    element
                        .find('.fc-event-title')
                        .append('<div class="fc-description"><i class="la la-stethoscope"></i>' + this.sanitize(subcontractor.name) + '</div>');
                }
            }
            if (_.has(model, 'asset.name')) {
                element
                    .find('.fc-list-item-title')
                    .append('<div class="fc-description"><i class="la la-sign-in"></i>' + this.sanitize(model.asset.name) + '</div>');
            }
            //list
        } else if (view?.type == 'listMonth') {
            if (_.has(model, 'serviceGroup.name') && !_.isNil(model.serviceGroup.name)) {
                element
                    .find('.fc-list-event-title')
                    .append('<div class="fc-description"><i class="la la-archive"></i>' + this.sanitize(model.serviceGroup.name) + '</div>');
            } else {
                if (_.has(model, 'service.name')) {
                    element
                        .find('.fc-list-event-title')
                        .append('<div class="fc-description"><i class="la la-hand-paper-o"></i>' + this.sanitize(model.service.name) + '</div>');
                }
            }
            if (_.get(model, 'contractor.subcontractors[0].name')) {
                element
                    .find('.fc-list-event-title')
                    .append(
                        '<div class="fc-description"><i class="la la-stethoscope"></i>' +
                            this.sanitize(model.contractor.subcontractors[0].name) +
                            '</div>',
                    );
            } else if (_.get(model, 'contractor.subcontractors[0].id')) {
                const subcontractor = subcontractors.find(sub => {
                    if (sub.id === model.contractor.subcontractors[0].id) return sub;
                });
                if (subcontractor) {
                    element
                        .find('.fc-list-event-title')
                        .append('<div class="fc-description"><i class="la la-stethoscope"></i>' + this.sanitize(subcontractor.name) + '</div>');
                }
            }
            if (_.has(model, 'asset.name')) {
                element
                    .find('.fc-list-event-title')
                    .append('<div class="fc-description"><i class="la la-sign-in"></i>' + this.sanitize(model.asset.name) + '</div>');
            }

            if (model.end < moment() && !model.visitId && !model.noShow) {
                element.find('.fc-list-event-title').append(
                    `
                    <div class="fc-description" ><i class="la la-warning m--font-danger"></i> 
                    Obravnava ni kreirana
                    </div>
                    `,
                );
            }

            if (_.get(model, 'noShow', false)) {
                element.find('.fc-list-event-title').append(
                    `
                    <div class="fc-description" ><i class="la la-user-times m--font-danger"></i> 
                        Stranke ni bilo na termin!
                    </div>
                    `,
                );
            }
            if (!_.isNil(model.isBs) && model.isBs) {
                element
                    .find('.fc-list-event-title')
                    .append(
                        `
                    <div class="fc-description" ><i class="la la-external-link m--font-warning"></i> 
                    Zunanja rezervacija (${this.sanitize(_.get(model, 'caseId', ''))})
                    </div>
                    `,
                    )
                    .append(this.getBusinessSubjectIcon(Number(this.sanitize(String(_.get(model, 'case.bsid', -1)))), true));
            }
            if (model.isRecurring) {
                element.find('.fc-list-event-title').append(
                    `
                    <div class="fc-description" ><i class="la la-retweet"></i> 
                    Ponavljajoča rezervacija
                </div>
                    `,
                );
            }
            if (_.has(model, 'customTagId')) {
                const tag = this.customTags.find(el => el.id === model.customTagId);
                element.find('.fc-list-event-title').append(
                    `
                    <div class="fc-description" ><i class="la la-star ${this.sanitize(_.get(tag, 'classColor', '??'))}"></i> 
                        ${this.sanitize(_.get(tag, 'name', '??'))}
                    </div>
                    `,
                );
            }
            if (!_.isNil(model.comment)) {
                element.find('.fc-list-event-title').append(
                    `
                        <div class="fc-description" ><i class="la la-sticky-note"></i> 
                            ${this.sanitize(_.get(model, 'comment', ''))} 
                        </div>
                    `,
                );
            }
            if (model.customer?.importantComments?.comments?.length > 0) {
                const combinedImportantComments = model.customer.importantComments.comments.map(el => el?.comment?.trim()).join(', ');
                element.find('.fc-list-event-title').append(
                    `
                    <div class="fc-description" ><i class="la la-exclamation"></i> 
                    ${this.sanitize(
                        combinedImportantComments?.length > 80 ? `${combinedImportantComments.substring(0, 80)}...` : combinedImportantComments,
                    )} 
                </div>
                    `,
                );
            }

            if (_.get(model, 'status', -1) === ReservationMode.DRAFT) {
                element.find('.fc-list-event-title').append(
                    `
                    <span class="m--font-danger"> (Osnutek)</span>
                    `,
                );
            }
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private generateIconsCalendar(model: any, element: any): any {
        const icons: string = this.generateIcons(model);
        element.prepend(`
            <div class="mf-event-status-icons">${icons}</div>
            `);
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private generateIcons(model: any): string {
        let statusIcons = '';

        // Ni kreirana obravna, in  je ze v preteklosti
        if (model.end < moment() && !model.visitId && !model.noShow) {
            statusIcons += '<i class="la la-warning m--font-danger"></i> <br/>';
        }
        // Obravnava ni zaključena
        if (model.visitId && !model.visitEndDate) {
            statusIcons += '<i class="la la-play m--font-warning"></i> <br/>';
        }

        if (model.isBs) {
            statusIcons += '<i class="la la-external-link m--font-warning"></i> <br/>';
        }
        //ponavljajoča rezervacija
        if (model.isRecurring) {
            statusIcons += '<i class="la la-retweet"></i> <br/>';
        }
        //stranke ni bilo
        if (model.noShow) {
            statusIcons += '<i class="la la-user-times m--font-danger"></i> <br/>';
        }
        //telemedicina
        if (model.telemed) {
            statusIcons += '<i class="la la-video-camera"></i> <br/>';
        }
        //telefonija
        if (model.phoneCall) {
            statusIcons += '<i class="la la-phone"></i> <br/>';
        }
        //zdravljenje
        if (model.treatmentId) {
            statusIcons += '<i class="la la-heart-o"></i><br/>';
        }
        if (model.originUrl) {
            statusIcons += this.getBusinessSubjectIcon(100);
        }

        //placano
        if (!_.isNil(model?.isPaid) && model?.originUrl) {
            if (model?.isPaid) {
                statusIcons += '<i class="la la-money"></i><br/>';
            } else {
                statusIcons += '<i class="la la-money m--font-warning"></i><br/>';
            }
        }

        statusIcons += this.getBusinessSubjectIcon(Number(this.sanitize(_.get(model, 'case.bsid', -1))));
        return statusIcons;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public generateGenericEventRender(element: any, model: any, view: any): any {
        element = $(element);

        if (
            view?.type == 'timeGridWeek' ||
            view?.type == 'resourceTimeGridDay' ||
            view?.type == 'resourceTimeGridWeek' ||
            view?.type == 'timeGridDay' ||
            view?.type == 'dayGridMonth'
        ) {
            this.generateGenericIcons(model, element);
            element
                .find('.fc-event-title')
                .append(
                    '<div class="fc-description"><i class="la la-stethoscope"></i>' +
                        this.sanitize(_.get(model, 'contractor.subcontractors[0].name', '')) +
                        '</div>',
                );
            if (model.asset) {
                element
                    .find('.fc-event-title')
                    .append('<div class="fc-description"><i class="la la-sign-in"></i>' + this.sanitize(_.get(model, 'title', '')) + '</div>');
            }
        } else if (element.find('.fc-list-item-title').length !== 0) {
            element
                .find('.fc-list-item-title')
                .append('<div class="fc-description"><i class="la la-hand-paper-o"></i>' + this.sanitize(_.get(model, 'title', '')) + '</div>');
        }

        return element;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public generateGenericPopupContent(model: any): any {
        let content = `
        <div class="fc-description" ><i class="la la-i-cursor"></i> 
            ${this.sanitize(_.get(model, 'event.extendedProps.data.title', ''))} 
        </div>
        <br/>
        <div class="fc-description" ><i class="la la-clock-o"></i> 
            ${moment(model.event.extendedProps.data.start).format('HH:mm')} - ${moment(model.event.extendedProps.data.end).format('HH:mm')}
        </div>

        <div class="fc-description" ><i class="la la-stethoscope"></i> 
            ${this.sanitize(_.get(model, 'event.extendedProps.data.contractor.subcontractors[0].name', ''))} 
        </div>
    `;

        if (_.get(model, 'event.extendedProps.data.asset')) {
            content += `
            <div class="fc-stethoscope" ><i class="la la-sign-in"></i>
                ${this.sanitize(_.get(model, 'event.extendedProps.data.asset.name', ''))}
            </div>
            `;
        }

        if (model.event.extendedProps.data.comment) {
            content += `
            <br />
            <div class="fc-description" ><i class="la la-sticky-note"></i> 
                ${this.sanitize(_.get(model, 'event.extendedProps.data.comment', ''))} 
            </div>
            `;
        }

        if (model.event.extendedProps.data.customTagId) {
            const tag = this.customTags.find(el => el.id === model.event.extendedProps.data.customTagId);
            content += `
            <div class="fc-description" ><i class="la la-star ${this.sanitize(_.get(tag, 'classColor', '??'))}"></i> 
                ${this.sanitize(_.get(tag, 'name', '??'))}
            </div>
            `;
        }
        return {
            title: 'Interna rezervacija',
            content: content,
            html: true,
            container: 'body',
            trigger: 'hover',
            placement: 'right',
            delay: 500,
            autoClose: true,
        };
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private generateGenericIcons(model: any, element: any): void {
        let statusIcons = '<i class="la la-building m--font-info"></i> <br/>';
        element = $(element);
        if (model.isRecurring) {
            statusIcons += '<i class="la la-retweet"></i>';
        }

        if (statusIcons) {
            element.prepend(`
                <div class="mf-event-status-icons">${this.sanitize(statusIcons)}</div>
                `);
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public generatePopupContent(model: any, subcontractors: Contractor[], assets: Asset[]): any {
        //dodani subcontractorji+prostori za mapiranje, ker so nepopolni podatki, kakšni subcontractorji ali prostori imajo samo ID brez imena
        if (model.view.type === 'listMonth') {
            //v pogledu Seznam nimamo popupa
            return;
        }
        if (model.event.allDay) {
            //prazniki nimajo popup contenta
            return;
        }
        model = model.event.extendedProps;
        // model: CalendarEvent
        let content = '';
        if (_.has(model, 'data.customer.name')) {
            content += `
            <div class="fc-description" ><i class="la la-user"></i> 
                ${this.sanitize(_.get(model, 'data.customer.name', ''))}  ${this.sanitize(_.get(model, 'data.customer.surname', ''))} 
            </div>
            `;
        } else {
            content += `
            <div class="fc-description" > 
                BREZ STRANKE
            </div>
            `;
        }

        if (_.has(model, 'data.customer.phone') && !_.isNil(model.data.customer.phone)) {
            content += `
            <div class="fc-description" ><i class="la la-phone"></i> 
                ${this.sanitize(model.data.customer.phone)}
            </div>
            `;
        }
        if (_.has(model, 'data.customer.email') && !_.isNil(model.data.customer.email)) {
            content += `
            <div class="fc-description" ><i class="la la-envelope"></i> 
                ${this.sanitize(model.data.customer.email)}
            </div>
            `;
        }

        content += `<br />`;

        if (_.has(model, 'data.serviceGroup.name')) {
            content += `
            <div class="fc-description" ><i class="la la-archive"></i> 
                ${this.sanitize(model.data.serviceGroup.name)}
            </div>
            `;
        } else {
            if (_.has(model, 'data.service.name')) {
                content += `
                <div class="fc-description" ><i class="la la-hand-paper-o"></i> 
                    ${this.sanitize(model.data.service.name)}
                </div>
                `;
            }
        }
        if (_.get(model, 'data.contractor.subcontractors[0].name')) {
            content += `
            <div class="fc-description" ><i class="la la-stethoscope"></i> 
            ${this.sanitize(_.get(model, 'data.contractor.subcontractors[0].name', ''))}

            </div>
            `;
        } else if (_.get(model, 'data.contractor.subcontractors[0].id')) {
            const subcontractor = subcontractors.find(sub => {
                if (sub.id === model.data.contractor.subcontractors[0].id) return sub;
            });

            if (subcontractor) {
                content += `
                <div class="fc-description" ><i class="la la-stethoscope"></i> 
                ${this.sanitize(subcontractor.name)}
    
                </div>
                `;
            }
        }

        if (model.data.asset) {
            if (_.get(model, 'data.asset.name')) {
                content += `
                <div class="fc-stethoscope" ><i class="la la-sign-in"></i>
                    ${this.sanitize(_.get(model, 'data.asset.name', ''))}
                </div>
                `;
            } else if (_.get(model, 'data.asset.id')) {
                const asset = assets.find(ass => {
                    if (ass.id === model.data.asset.id) return ass;
                });

                if (asset) {
                    content += `
                    <div class="fc-stethoscope" ><i class="la la-sign-in"></i>
                        ${this.sanitize(asset.name)}
                    </div>
                    `;
                }
            }
        }

        if (model.data.treatmentId) {
            content += `
            <div class="fc-description" ><i class="la la-heart-o"></i>
                Zdravljenje
            </div>
            `;
        }
        //Obravnava
        if (model.data.end < moment() && !model.data.visitId && !model.data.noShow) {
            content += `
            <div class="fc-description" ><i class="la la-warning m--font-danger"></i> 
                Obravnava ni kreirana
            </div>
            `;
        }

        if (model.data.visitId && !model.data.visitEndDate) {
            content += `
            <div class="fc-description" ><i class="la la-play m--font-warning"></i> 
                Obravnava ni zaključena
            </div>
            `;
        }

        if (model.data.visitId && model.data.visitEndDate) {
            content += `
            <div class="fc-description" ><i class="la la-check m--font-success"></i> 
                Obravnava zaključena
            </div>
            `;
        }

        if (model.data.noShow) {
            content += `
            <div class="fc-description" ><i class="la la-user-times m--font-danger"></i> 
                Stranke ni bilo na termin!
            </div>
            `;
        }

        // if (model.data.selfFunding) {
        //     content += `
        //         <div class="fc-description" ><i class="la la-money m--font-danger"></i>
        //             Samoplačnik
        //         </div>
        //         `;
        // }

        if (model.data.telemed) {
            content += `
            <div class="fc-description" ><i class="la la-video-camera"></i> 
                Telemedicina
            </div>
            `;
        }

        if (model.data.phoneCall) {
            content += `
            <div class="fc-description" ><i class="la la-phone"></i> 
                Telefonija
            </div>
            `;
        }

        if (model.data.isBs) {
            content += `
            <div class="fc-description" ><i class="la la-external-link m--font-warning"></i> 
                Zunanja rezervacija ${this.sanitize(_.get(model, 'data.case.caseInternalId', ''))} (${this.sanitize(_.get(model, 'data.caseId', ''))})
            </div>
            `;
            content += this.getBusinessSubjectIcon(Number(this.sanitize(_.get(model, 'data.case.bsid', -1))), true);
        }
        if (this.sanitize(_.get(model, 'data.reservationType', ''))) {
            content += `
                <div> ${this.getHDAppIcon(this.sanitize(_.get(model, 'data.reservationType', '')), true)} </div>
            `;
        }
        if (model.data.isRecurring) {
            content += `
            <div class="fc-description" ><i class="la la-retweet"></i> 
                Ponavljajoča rezervacija
            </div>
            `;
        }
        if (model.data.customTagId) {
            // public customTags: any = tags.CUSTOM_TERMS_TAGS;
            const tag = this.customTags.find(el => el.id === model.data.customTagId);
            content += `
            <div class="fc-description" ><i class="la la-star ${this.sanitize(_.get(tag, 'classColor', '??'))}"></i> 
                ${this.sanitize(_.get(tag, 'name', '??'))}
            </div>
            `;
        }
        if (model.data.comment) {
            content += `
            <br />
            <div class="fc-description" ><i class="la la-sticky-note"></i> 
            ${this.sanitize(_.get(model, 'data.comment', '')?.length > 80 ? `${model.data.comment.substring(0, 80)}...` : model.data.comment)} 
            </div>
            `;
        }
        if (model.data?.customer?.importantComments?.comments?.length > 0) {
            const combinedImportantComments = model.data.customer.importantComments.comments.map(el => el?.comment).join(', ');
            content += `
            <div class="fc-description" ><i class="la la-exclamation"></i> 
                ${this.sanitize(
                    combinedImportantComments?.length > 80 ? `${combinedImportantComments.substring(0, 80)}...` : combinedImportantComments,
                )} 
            </div>
            `;
        }
        //bookirano iz widgeta
        if (model.data.originUrl) {
            content += `
            <div class="fc-description" ><i class="la la-external-link"></i> 
                ${this.sanitize(this.originPipe.transform(_.get(model, 'data.originUrl', '')))} 
            </div>
            `;
        }
        //placilni modul
        if (!_.isNil(model?.data?.isPaid) && model?.data?.originUrl) {
            if (model?.data?.isPaid) {
                content += `
                <div class="fc-description" ><i class="la la-money"></i> 
                    Plačano
                </div>
                `;
            } else {
                content += `
                <div class="fc-description" ><i class="la la-money  m--font-warning"></i> 
                    Ni plačano
                </div>
                `;
            }
        }

        let title = moment(model.data.start).format('HH:mm') + ' - ' + moment(model.data.end).format('HH:mm');
        if (_.get(model, 'status', -1) === ReservationMode.DRAFT) {
            title += ' <span class="m--font-danger"> (Osnutek)</span>';
        }
        return {
            title: title,
            content: content,
            html: true,
            container: 'body',
            trigger: 'hover',
            placement: 'right',
            delay: 500,
            autoClose: true,
        };
    }

    private getBusinessSubjectIcon(buis: number, isCaption: boolean = false): string {
        let text = '';
        let cssNewLine = 'mf-bs-icon-nl';
        if (isCaption) {
            cssNewLine = '';
        }
        switch (buis) {
            case 1:
            case 11:
            case 111:
                text = `<img class="${cssNewLine}" height="16" src="../../../../assets/app/media/img/bu/generali.svg" alt="Generali" />`;
                if (isCaption) {
                    text += `<span class="pl-1">Generali</span>`;
                }
                return text;
            case 2:
                text = `<img class="${cssNewLine}" height="16" src="../../../../assets/app/media/img/bu/triglav.svg" alt="Triglav" />`;
                if (isCaption) {
                    text += `<span class="pl-1">Triglav</span>`;
                }
                return text;
            case 7:
                text = `<img class="${cssNewLine}" height="16" src="../../../../assets/app/media/img/bu/vzajemna.svg" alt="Vzajemna" />`;
                if (isCaption) {
                    text += `<span class="pl-1">Vzajemna</span>`;
                }
                return text;

            case 9:
                text = `<img class="${cssNewLine}" height="16" src="../../../../assets/app/media/img/bu/sava_icon.svg" alt="Sava" />`;
                if (isCaption) {
                    text += `<span class="pl-1">Sava</span>`;
                }
                return text;
            case 12:
                text = `<img class="${cssNewLine}" height="16" src="../../../../assets/app/media/img/bu/vox_medica.svg" alt="Vox Medica" />`;
                if (isCaption) {
                    text += `<span class="pl-1">Vox Medica</span>`;
                }
                return text;
            case 23:
                text = `<img class="${cssNewLine}" height="16" src="../../../../assets/app/media/img/bu/vita_icon.svg" alt="Vita" />`;
                if (isCaption) {
                    text += `<span class="pl-1">Vita</span>`;
                }
                return text;
            case 24:
                text = `<img class="${cssNewLine}" height="16" src="../../../../assets/app/media/img/bu/prva.svg" alt="PRVA" />`;
                if (isCaption) {
                    text += `<span class="pl-1">PRVA</span>`;
                }
                return text;
            case 3:
                text = `<img class="${cssNewLine}" height="16" src="../../../../assets/app/media/img/bu/merkur_2023.svg" alt="Merkur" />`;
                if (isCaption) {
                    text += `<span class="pl-1">Merkur</span>`;
                }
                return text;
            case 100:
                return `<img class="${cssNewLine}" height="16" src="../../../../assets/app/media/img/bu/medifit_icon.svg" alt="Medifit" />`;
            default:
                return ``;
        }
    }

    private getHDAppIcon(reservationType: string, isCaption: boolean = false): string {
        let text = '';
        let cssNewLine = 'mf-bs-icon-nl';
        if (isCaption) {
            cssNewLine = '';
        }
        switch (reservationType) {
            case 'HDD':
            case 'HDP':
                text = `<img class="${cssNewLine}" style="padding-left: 1px; padding-bottom: 1px;" height="15" src="../../../../assets/app/media/img/hd/znak_grad-08.svg" alt="Halo Doktor" />`;
                if (isCaption) {
                    text += `<span class="pl-1">Halo Doktor</span>`;
                }
                return text;
            case 'SAVAD':
            case 'SAVAP':
                text = `<img class="${cssNewLine}" style="padding-left: 1px; padding-bottom: 1px;" height="15" src="../../../../assets/app/media/img/znd/zdravnik-na-daljavo-icon-color.svg" alt="Zdravnik na daljavo" />`;
                if (isCaption) {
                    text += `<span class="pl-1">Zdravnik na daljavo</span>`;
                }
                return text;
            default:
                return ``;
        }
    }
}
